import React from 'react';
import { BarChart, Bar, XAxis, Tooltip, ResponsiveContainer, LabelList, YAxis } from 'recharts';

const renderCustomizedLabel = (props) => {
    const { x, y, width, value } = props;
    const radius = 10;

    if(value === 0){//Because of the scale='log' the 0 is being considarate infinite, that gives an error. => solves that error by not considering the 0 vlues.
      return (
          <g>
            {/* <circle cx={x + width / 2} cy={y - radius} r={radius} fill="#8884d8" /> */}
            {/* <text x={x + width / 2} y={width + 140} fill="#8884d8" textAnchor="middle">
                0
            </text> */}
          </g>
      );
    }

    return (
        <g>
          {/* <circle cx={x + width / 2} cy={y - radius} r={radius} fill="#8884d8" /> */}
          <text x={x + width / 2} y={y - radius} fill="#8884d8" textAnchor="middle" fontSize='small'>{/*dominantBaseline="top"*/}
              {value}
          </text>
        </g>
    );
};

export const SimpleVerticalBarChart = (props) => {
    return(
      <ResponsiveContainer width="100%">
        <BarChart
          // width={500}
          // height={400}
          data={props.data}
          margin={{
            top: 30,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          <XAxis dataKey="name" fontSize={8} angle="330" interval={0} tickMargin={10} height={30}/>
          <YAxis dataKey="uv" hide="true" domain={[0.1, 'auto']} />{/* scale='log' allowDataOverflow={true} */}
          <Tooltip />
          {/* <Legend /> */}
          <Bar dataKey="uv" fill="#4473ca" barSize={15} name={props.name ?? ""}>
            <LabelList dataKey="uv" content={renderCustomizedLabel}/>
          </Bar>
          {/* <Bar dataKey="uv" fill="#82ca9d" /> */}
        </BarChart>
      </ResponsiveContainer>
    )
};